import { videos } from "@/mocks/videos";

export default function Trending() {
  const hot = videos.filter((v) => v.hot).slice(0, 6);

  return (
    <section id="hot" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between">
          <div>
            <p className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-fire-line"></i>
              热门精选
            </p>
            <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">
              今日吃瓜热门视频
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              播放量最高的精选内容，点开就能看，快跟上大家的节奏。
            </p>
          </div>
          <a
            href="#videos"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {hot.map((v, i) => (
            <article
              key={v.id}
              data-product-shop=""
              className="group overflow-hidden rounded-lg bg-background-100 ring-1 ring-background-200 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative w-full">
                <img
                  src={v.cover}
                  alt={v.title}
                  title={`吃瓜视频 ${v.title}`}
                  className="aspect-video w-full object-cover"
                />
                <span className="absolute left-3 top-3 flex h-6 items-center rounded-md bg-primary-500 px-2 text-xs font-medium text-background-50">
                  <i className="ri-fire-line mr-1"></i>Top {i + 1}
                </span>
                <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs text-background-50">
                  <i className="ri-time-line"></i>
                  {v.duration}
                </span>
                <div className="absolute inset-0 flex items-center justify-center bg-foreground-950/30 opacity-0 transition-opacity group-hover:opacity-100">
                  <button
                    type="button"
                    aria-label={`播放 ${v.title}`}
                    className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50"
                  >
                    <i className="ri-play-fill text-xl"></i>
                  </button>
                </div>
              </div>
              <div className="p-4">
                <span className="inline-flex rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-800">
                  {v.category}
                </span>
                <h3 className="mt-2 line-clamp-2 text-sm font-medium text-foreground-950 md:text-base">
                  {v.title}
                </h3>
                <p className="mt-2 hidden text-xs text-foreground-600 sm:block sm:text-sm line-clamp-2">
                  {v.description}
                </p>
                <div className="mt-3 flex items-center gap-4 text-xs text-foreground-600">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {v.views}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {v.date}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}